export function properCase(str) {
    const cap = str.split(' ').map(i => i[0].toUpperCase() + i.substring(1).toLowerCase()).join(' ');
    return cap;
}